export const ROOT_BREADCRUMBS = Object.freeze({
  PROJECTS: {
    label: t('Projects'),
    href: '#/forms',
  },
  MY_LIBRARY: {
    label: t('Library'),
    href: '#/library/my-library',
  },
  PUBLIC_COLLECTIONS: {
    label: t('Public Collections'),
    href: '#/library/public-collections',
  },
});

